import React from 'react';
import logo from '../../img/bestzon.png';
import './Header.css';
const Header = () => {
  return (
    <header>
      <div className='container header'>
        <div className='logo'>
          <a href='home'>
            <img src={logo} alt='' />
          </a>
        </div>
        <nav className='main-menu'>
          <ul>
            <li>
              <a href='home'>Home</a>
            </li>
            <li>
              <a href='shop'>About</a>
            </li>
            <li>
              <a href='review'>Contact</a>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
